import { render, staticRenderFns } from "./EarlyRelease.vue?vue&type=template&id=094e91f4&scoped=true&"
import script from "./EarlyRelease.vue?vue&type=script&lang=ts&setup=true&"
export * from "./EarlyRelease.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./EarlyRelease.vue?vue&type=style&index=0&id=094e91f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e91f4",
  null
  
)

export default component.exports